import { createContext } from "react";

import {
  TerraformProviderVersionWithArtifacts,
  TerraformProviderVersionWithDocs,
  TerraformProviderWithVersions,
} from "../types";
import { ProviderDocTreeNode } from "./helpers";

type ProviderVersion = TerraformProviderVersionWithArtifacts | TerraformProviderVersionWithDocs;

type ProviderVersionDocsContextType = {
  provider: TerraformProviderWithVersions;
  version: ProviderVersion;
  docs: ProviderDocTreeNode[];
};

export const ProviderVersionDocsContext = createContext<ProviderVersionDocsContextType | undefined>(
  undefined
);
ProviderVersionDocsContext.displayName = "ProviderVersionDocsContext";
